<script>
import { Sortable } from '@shopify/draggable';

export default {
  provide() {
    return {
      itemClass: this.itemClass,
      handleClass: this.handleClass,
    };
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    itemClass: {
      type: String,
      default: 'sortable-item',
    },
    handleClass: {
      type: String,
      default: 'sortable-handle',
    },
  },
  mounted() {
    const sortable = new Sortable(this.$el, {
      draggable: `.${this.itemClass}`,
      handle: `.${this.handleClass}`,
      mirror: {
        constrainDimensions: true,
      },
    }).on('sortable:stop', ({ oldIndex, newIndex }) => {
      if (oldIndex != newIndex) {
        this.$emit('onOrderChange', [this.value, oldIndex, newIndex]);
      }
    });
      
    this.$on('hook:destroyed', () => {
      sortable.destroy();
    });
  },
  methods: {
    move(items, oldIndex, newIndex) {
      const itemRemovedArray = [
        ...items.slice(0, oldIndex),
        ...items.slice(oldIndex + 1, items.length)
      ];

      const newItem = JSON.parse(JSON.stringify(items[oldIndex]));

      const result = [
        ...itemRemovedArray.slice(0, newIndex),
        newItem,
        ...itemRemovedArray.slice(newIndex, itemRemovedArray.length)
      ];

      const startChangeIndex = oldIndex > newIndex ? newIndex : oldIndex,
        endChangeIndex = oldIndex > newIndex ? oldIndex : newIndex;

      for (let i = startChangeIndex; i <= endChangeIndex; i++) {
        result[i].priority = i;
      }

      return result;
    }
  },
  render() {
    return this.$scopedSlots.default({
      tableRows: this.value,
    });
  }
};
</script>